import { type LoaderFunctionArgs } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import Feed from '#app/components/feed/feed.tsx'

export const loader = async ({
	params,
	context,
	request,
}: LoaderFunctionArgs) => {
	const url = new URL(request.url)
	const filter = url.searchParams.get('filter')

	return {
		filter: filter,
		atomicLoreUrl: url.origin,
	}
}

export default function feedPage() {
	const { filter, atomicLoreUrl } = useLoaderData<{
		filter?: string
		atomicLoreUrl: string
	}>()

	return <Feed filter={filter} atomicLoreUrl={atomicLoreUrl} />
}
